"use strict";
exports.__esModule = true;
exports.MillenniumTime = void 0;
var MillenniumDateTime_1 = require("./MillenniumDateTime");
var SimpleDateFormat_1 = require("./SimpleDateFormat");
var SECONDS_PER_DAY = 86400;
/**
 * Four variants:
 * * One argument - either a time number or a MillenniumDateTime
 * * Three arguments - hour, minute and second
 * * Four argumenst - day, hour, minute and second
 */
var MillenniumTime = /** @class */ (function () {
    function MillenniumTime(param1, param2, param3, param4) {
        if (arguments.length === 1) {
            var time = param1;
            // const MillenniumDateTime = require("./MillenniumDateTime");
            if (time instanceof MillenniumDateTime_1.MillenniumDateTime) {
                this.timeNumber = time.getMts() % SECONDS_PER_DAY;
            }
            else {
                this.timeNumber = time;
            }
        }
        else if (arguments.length === 3) {
            this.timeNumber = param1 * 3600 + param2 * 60 + param3;
        }
        else if (arguments.length === 4) {
            this.timeNumber =
                param1 * SECONDS_PER_DAY + param2 * 3600 + param3 * 60 + param4;
        }
        else {
            this.timeNumber = 0;
        }
    }
    MillenniumTime.now = function () {
        var now = new Date();
        return new MillenniumTime(now.getHours(), now.getMinutes(), now.getSeconds());
    };
    MillenniumTime.prototype.getTimeNumber = function () {
        return this.timeNumber;
    };
    MillenniumTime.prototype.getHours = function () {
        return Math.floor(this.timeNumber / 3600);
    };
    MillenniumTime.prototype.getMinutes = function () {
        return Math.floor((this.timeNumber % 3600) / 60);
    };
    MillenniumTime.prototype.getSeconds = function () {
        return this.timeNumber % 60;
    };
    MillenniumTime.prototype.addSeconds = function (seconds) {
        return new MillenniumTime(this.getTimeNumber() + seconds);
    };
    MillenniumTime.prototype.format = function (format) {
        format = format || "HHmmss";
        return SimpleDateFormat_1.SimpleDateFormat.format(this, format); // TODO: We have a bug here, the types don't add up. remove any.
    };
    MillenniumTime.prototype.toString = function () {
        return this.format();
    };
    MillenniumTime.prototype.isBetween = function (start, end, inclusive) {
        inclusive = inclusive === undefined ? true : inclusive;
        if (inclusive) {
            return this.timeNumber >= start.timeNumber && this.timeNumber <= end.timeNumber;
        }
        return this.timeNumber > start.timeNumber && this.timeNumber < end.timeNumber;
    };
    MillenniumTime.prototype.equals = function (obj) {
        if (this === obj) {
            return true;
        }
        if (obj === null || obj === undefined) {
            return false;
        }
        if (!(obj instanceof MillenniumTime)) {
            return false;
        }
        return this.timeNumber === obj.getTimeNumber();
    };
    return MillenniumTime;
}());
exports.MillenniumTime = MillenniumTime;
